// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1HSNZ","tableContainer":"styles_tableContainer__s9aK2","rowsWrapper":"styles_rowsWrapper__o6q-z","rowsContainer":"styles_rowsContainer__1NUzI"};